// import React, { useState } from "react";
// import { mapTableRows } from "../../../../utils/mapTableRows";
// import {
//   Alert,
//   Button,
//   FormFieldSet,
//   Modal,
//   NewTable,
// } from "../../../../components";
// import { additionalNotifiers } from "../../../../assets/data/candidatesData";

// const AdditionalNotifiers = () => {
//   const [abdultSelect, setAbdulSelect] = useState("");

//   const [addNotifiersModal, setAddNotifiersModal] = useState(false);

//   const tableData = additionalNotifiers;

//   const columns = [
//     { key: "employeeName", label: "Employee Name", sortable: false },
//     {
//       key: "employmentType",
//       label: "Employment Type",
//       sortable: false,
//     },
//     {
//       key: "category",
//       label: "Category",
//       sortable: false,
//     },
//     {
//       key: "additionalNotifiers",
//       label: "Additional Notifiers",
//       sortable: false,
//     },
//     {
//       key: "actions",
//       label: "Actions",
//       render: (row) => (
//         <Button
//           type="icon"
//           variant="text"
//           icon="add"
//           size="xs"
//           color="black"
//           onClick={() => setAddNotifiersModal(true)}
//         />
//       ),
//       sortable: false,
//     },
//   ];

//   const mappedRows = mapTableRows(tableData, columns);

//   return (
//     <div>
//       <NewTable
//         showCheckbox
//         rows={mappedRows}
//         columns={columns}
//         toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
//         customSection={
//           <div className="flex gap-1">
//             <Button
//               variant="contained"
//               size="sm"
//               title={"Add Additional Notifiers"}
//               color="black"
//               onClick={() => setAddNotifiersModal(true)}
//               icon="person_add"
//             />
//           </div>
//         }
//       />
//       <Modal
//         isOpen={addNotifiersModal}
//         onClose={() => setAddNotifiersModal(false)}
//         title="Additional Notifiers"
//         width="max-w-4xl"
//       >
//         <div>
//           <div className="mb-20">
//             <p className="text-sm">
//               Select the User(s) you want as Additional notifier(s) :
//             </p>
//             <div className="w-[60%] lg:w-[50%] xl:w-[40%] mt-2">
//               <FormFieldSet
//                 type="select"
//                 title=""
//                 placeholder="Abdul Waseem syed (EMP-1001)"
//                 onChange={setAbdulSelect}
//                 value={abdultSelect}
//                 options={[
//                   {
//                     label: "Abdul Waseem syed (EMP-1001)",
//                     value: "Abdul Waseem syed (EMP-1001)",
//                   },
//                   {
//                     label: "Abdul Waseem syed (EMP-1001)",
//                     value: "Abdul Waseem syed (EMP-1001)",
//                   },
//                   {
//                     label: "Abdul Waseem syed (EMP-1001)",
//                     value: "Abdul Waseem syed (EMP-1001)",
//                   },
//                 ]}
//               />
//             </div>
//           </div>
//           <div className="flex gap-3 justify-end">
//             <Button
//               variant="outlined"
//               title={"Cancel"}
//               onClick={() => setAddNotifiersModal(false)}
//             />
//             <Button title={"OK"} onClick={() => setAddNotifiersModal(false)} />
//           </div>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default AdditionalNotifiers;
import React, { useState } from "react";
import { mapTableRows } from "../../../../utils/mapTableRows";
import {
  Alert,
  Button,
  FormFieldSet,
  Modal,
  TableAdv,
} from "../../../../components";
import { additionalNotifiers } from "../../../../assets/data/candidatesData";

const AdditionalNotifiers = () => {
  const [abdultSelect, setAbdulSelect] = useState("");
  const [addNotifiersModal, setAddNotifiersModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);

  const tableData = additionalNotifiers;

  const columns = [
    { key: "employeeName", label: "Employee Name", sortable: false },
    {
      key: "employmentType",
      label: "Employment Type",
      sortable: false,
    },
    {
      key: "category",
      label: "Category",
      sortable: false,
    },
    {
      key: "additionalNotifiers",
      label: "Additional Notifiers",
      sortable: false,
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          icon="add"
          size="xs"
          color="black"
          onClick={() => setAddNotifiersModal(true)}
        />
      ),
      sortable: false,
    },
  ];

  // Add id field to each row for TableAdv
  const mappedRows = mapTableRows(
    tableData.map((item, index) => ({
      ...item,
      id: item.id || index, // Ensure each row has an id
    })),
    columns,
  );

  // Handle selection change from TableAdv
  const handleSelectionChange = (selectedRowIds) => {
    console.log("Selected row IDs:", selectedRowIds);
    setSelectedRows(selectedRowIds);

    // Find the actual row objects from mappedRows
    const selectedRowObjects = mappedRows.filter((row) =>
      selectedRowIds.includes(row.id),
    );

    console.log("Selected row objects:", selectedRowObjects);

    // Extract employee IDs if needed
    const employeeIds = selectedRowObjects.map((row) => row.id);
    setSelectedEmployeeIds(employeeIds);
  };

  return (
    <div className="flex-1 flex overflow-hidden">
      <TableAdv
        showCheckbox
        rows={mappedRows}
        columns={columns}
        onSelectionChange={handleSelectionChange}
        defaultSelectedRows={selectedRows}
        toolbarRight={{
          filter: false,
          search: false,
          add: [
            {
              component: (
                <Button
                  variant="contained"
                  size="sm"
                  title={"Add Additional Notifiers"}
                  color="black"
                  onClick={() => setAddNotifiersModal(true)}
                  icon="person_add"
                />
              ),
            },
          ],
        }}
        tableId="additional-notifiers-table"
      />
      <Modal
        isOpen={addNotifiersModal}
        onClose={() => setAddNotifiersModal(false)}
        title="Additional Notifiers"
        width="max-w-4xl"
      >
        <div>
          <div className="mb-20">
            <p className="text-sm">
              Select the User(s) you want as Additional notifier(s) :
            </p>
            <div className="w-[60%] lg:w-[50%] xl:w-[40%] mt-2">
              <FormFieldSet
                type="select"
                title=""
                placeholder="Abdul Waseem syed (EMP-1001)"
                onChange={setAbdulSelect}
                value={abdultSelect}
                options={[
                  {
                    label: "Abdul Waseem syed (EMP-1001)",
                    value: "Abdul Waseem syed (EMP-1001)",
                  },
                  {
                    label: "Abdul Waseem syed (EMP-1002)",
                    value: "Abdul Waseem syed (EMP-1002)",
                  },
                  {
                    label: "Abdul Waseem syed (EMP-1003)",
                    value: "Abdul Waseem syed (EMP-1003)",
                  },
                ]}
              />
            </div>
          </div>
          <div className="flex gap-3 justify-end">
            <Button
              variant="outlined"
              title={"Cancel"}
              onClick={() => setAddNotifiersModal(false)}
            />
            <Button title={"OK"} onClick={() => setAddNotifiersModal(false)} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AdditionalNotifiers;